import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useEffect } from "react";
import { router } from "./router";
import { useAuthStore } from "./store/auth.store";
import { saveExtensionId, sendTokenToExtension } from "./lib/extension";
import { getSession } from "./lib/auth";
import env from "./env";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 dakika
      retry: 1,
    },
  },
});

function AuthInitializer({ children }: { children: React.ReactNode }) {
  const initializeFromStorage = useAuthStore((s) => s.initializeFromStorage);

  useEffect(() => {
    initializeFromStorage();

    // URL'den extension ID yakala ve token gönder
    const params = new URLSearchParams(window.location.search);
    const extId = params.get("ext");
    if (extId) saveExtensionId(extId);

    // Eklentinin token'i 7 gunde doluyor; eskiden yalnizca giriste gonderiliyordu
    // ve eklenti "Gecersiz veya suresi dolmus token" veriyordu. Panel her
    // acildiginda ve sekmeye donuldugunde gecerli token'i eklentiye tazele.
    const sync = () => {
      const session = getSession();
      if (session?.token) sendTokenToExtension(session.token).catch(() => {});
    };
    sync();
    const onVisible = () => { if (document.visibilityState === "visible") sync(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [initializeFromStorage]);

  return <>{children}</>;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthInitializer>
        <RouterProvider router={router} />
      </AuthInitializer>
      {env.IS_DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
